<div class="program-steps card">
  <div #stepContainer class="program-steps__scroll">
    @for (step of steps; track step; let i = $index) {
    <div
      id="step-{{ i }}"
      class="program-steps__step-container"
      [ngClass]="{
        'program-steps__step-container--has-scroll': hasOverflow,

        'program-steps__step-container--answered': currentStepIndex > i,
        'program-steps__step-container--start': i === 0
      }"
    >
      @if(i > 0 && i < steps?.length) {
      <div class="program-steps__line"></div>
      } @if(currentStepIndex > i) {
      <fa-icon class="program-steps__icon" [icon]="checkIcon"></fa-icon>
      } @else {
      <fa-icon class="program-steps__icon" [icon]="listIcon"></fa-icon>
      }
    </div>

    }
  </div>
</div>
<div class="program-steps__title-container">
  <span class="program-steps__description">
    {{ stepDescription | translate }}
  </span>
</div>
